import { render, staticRenderFns } from "./ApplicantFormStep3.vue?vue&type=template&id=0b3437e6&scoped=true"
import script from "./ApplicantFormStep3.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3437e6",
  null
  
)

export default component.exports